import React, { useState, useEffect } from 'react';

interface CountdownTimerProps {
  initialTime: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ initialTime }) => {
  const [timeRemaining, setTimeRemaining] = useState(initialTime);

  useEffect(() => {
    // Return early if the initial time is less than zero
    if (initialTime < 0) {
      setTimeRemaining(0);
      return;
    }

    // Set up the interval to decrease the timer
    const intervalId = setInterval(() => {
      setTimeRemaining(prevTime => {
        const newTime = prevTime - 1;
        return newTime >= 0 ? newTime : 0;
      });
    }, 1000);

    // Cleanup function to clear the interval when the component unmounts or initialTime changes
    return () => clearInterval(intervalId);
  }, [initialTime]);  // React to changes in initialTime

  // Convert timeRemaining into days, hours, minutes, and seconds
  const days = Math.floor(timeRemaining / (60 * 60 * 24));
  const hours = Math.floor((timeRemaining % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((timeRemaining % (60 * 60)) / 60);
  const seconds = Math.floor(timeRemaining % 60);

  // Format numbers with leading zeros if necessary
  const formattedDays = days < 10 ? `0${days}` : days;
  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return (
    <span>
        {`${formattedDays}d ${formattedHours}h ${formattedMinutes}m ${formattedSeconds}s`}
    </span>
  );
};

export default CountdownTimer;
